import React from 'react';
import {useServiceBase} from "../ReactTable/useServiceBase";
import Page from "../Page";
import {LoadingWrapper} from "../LoadingWrapper";
import EditableReactTableV2 from "../ReactTable/EditableReactTableV2";
import {EditFormTextInputField} from "../ReactTable/EditRecordForm";
import {Breadcrumbs} from "../Breadcrumbs";
import {INDEX_FIELD} from "../ReactTable/common_custom_columns";

const CircleCiRepos = () => {

    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/circleCiRepos/`;
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl});

    const customColumns = [
        {header: 'Repo Name', accessorKey: 'name'},
        {header: 'Workflow Name', accessorKey: 'workflowName'},
        {header: 'Branch', accessorKey: 'branch'}
    ]

    return <Page name={'CircleCi Repos'}
                 breadCrumbs={<Breadcrumbs items={[
                     {label: "Last Production Deployment", to: '/lastProductionDeployment'},
                     {label: "Circle Ci Repos"}
                 ]}/>}>
        <LoadingWrapper loading={loading}>
            <EditableReactTableV2
                filterable
                data={data.data}
                columns={customColumns}
                editTable={[
                    INDEX_FIELD,
                    {id: "name", Component: args => <EditFormTextInputField  {...args} isRequired/>},
                    {id: "workflowName", Component: args => <EditFormTextInputField  {...args} isRequired/>},
                    {id: "branch", Component: args => <EditFormTextInputField  {...args} isRequired/>}
                ]}
                onRowEditConfirmed={onRowEditConfirmed}
                onRowDeleteConfirmed={onRowDeleteConfirmed}
            />
        </LoadingWrapper>
    </Page>;
};

export default CircleCiRepos;